import parse from '@teetsh/app/src/utils/time/parse';
import isValid from '@teetsh/app/src/utils/time/isValid';
import { Gender } from 'types/gender';

export function getGenderFromString(v?: string): Gender | undefined {
  if (!v || v === '') {
    return undefined;
  }
  const boyRegex = /^[g,G,H,h,M,m]/g;
  if (v.match(boyRegex)) {
    return 'H';
  }
  const girlRegex = /^[f,F]/g;
  if (v.match(girlRegex)) {
    return 'F';
  }
  return undefined;
}

export function getBirthday(v: string) {
  if (!v || v === '') {
    return undefined;
  }
  let res = parse(v, 'yyyy-MM-dd');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'dd-MM-yyyy');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'yyyy.MM.dd');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'dd.MM.yyyy');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'dd/MM/yyyy');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'yyyy/MM/dd');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'yyyy MM dd');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'dd MM yyyy');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'dd MMMM yyyy');
  if (isValid(res)) {
    return res;
  }
  res = parse(v, 'dd MMMM yy');
  if (isValid(res)) {
    return res;
  }
  return undefined;
}
